<template>
    <div class="page">
        <div class="topBox">
            <!-- <div class="topTitle">ABOUT HAILUN</div>
            <div class="topTitle2">关于海伦</div>
            <div class="line"></div> -->
        </div>

        <pageBreadcrumb :option="nav_option" />

        <div class="wrap">
            <div class="topTypeFlexBox">
                <div class="title" :class="{ active: !!(pageType == 0) }" @click="switchPageType(0)">{{ $t('公司简介') }}</div>
                <div class="line"></div>
                <div class="title" :class="{ active: !!(pageType == 1) }" @click="switchPageType(1)">{{ $t('创始人介绍') }}</div>
                <div class="line"></div>
                <div class="title" :class="{ active: !!(pageType == 2) }" @click="switchPageType(2)">{{ $t('企业荣誉') }}</div>
                <div class="line"></div>
                <div class="title" :class="{ active: !!(pageType == 3) }" @click="switchPageType(3)">{{ $t('发展历程') }}</div>
                <div class="line"></div>
                <div class="title" :class="{ active: !!(pageType == 4) }" @click="switchPageType(4)">{{ $t('生产线展示') }}</div>
            </div>

            <!-- 公司简介 -->
            <div class="myPageBox" v-show="pageType == 0">
                <div class="bigFlexBox">
                    <div class="leftBox">
                        <div style="width: 100%">
                            <div class="title">{{ $t('公司简介') }}</div>
                            <div class="introStr" v-html="this.lang == 'en' ? pageData.enContent : pageData.content"></div>
                        </div>
                        <div class="bottomNumBox">
                            <div>
                                <div class="bigNumBox">
                                    <div class="bigNum">{{ pageData.expand1Num }}<span class="addNum">+</span></div>
                                    <div class="bigNumText">{{ $t('项') }}</div>
                                </div>
                                <div class="bigNumNorText">{{ this.lang == 'en' ? pageData.enExpand1 : pageData.expand1Text }}</div>
                            </div>
                            <div>
                                <div class="bigNumBox">
                                    <div class="bigNum">{{ pageData.expand2Num }}<span class="addNum">+</span></div>
                                    <div class="bigNumText">{{ $t('项') }}</div>
                                </div>
                                <div class="bigNumNorText">{{ this.lang == 'en' ? pageData.enExpand2 : pageData.expand2Text }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="rightBox">
                        <el-image class="img" :src="pageData.thumb" fit="cover"></el-image>
                    </div>
                </div>
            </div>

            <!-- 创始人介绍 -->
            <div class="myPageBox2" v-show="pageType == 1">
                <div class="topTitle">{{ $t('创始人介绍') }}</div>
                <div v-for="(item, index) in pageData2.list" :key="index">
                    <div class="flexBox">
                        <el-image class="peopleImg" :src="item.thumb" fit="cover"></el-image>
                        <div class="rightBox">
                            <div class="nameFlexBox">
                                <div class="name">{{ lang == 'en' ? item.enTitle : item.title }}</div>
                                <div class="name2">{{ lang == 'en' ? item.enDescription : item.description }}</div>
                            </div>
                            <div class="contentText" v-html="lang == 'en' ? item.enContent : item.content"></div>
                        </div>
                    </div>
                    <div class="line" v-if="index != pageData2.list.length - 1"></div>
                </div>
            </div>

            <!-- 企业荣誉 -->
            <div class="myPageBox3" v-show="pageType == 2">
                <div class="topTitle">{{ $t('企业荣誉') }}</div>
                <div class="flexBox">
                    <div class="imgBox" v-for="(item, index) in pageData3.list" :key="index">
                        <el-image class="img" :src="item.image" :preview-src-list="[item.image]" :initial-index="0" fit="cover"></el-image>
                        <div class="title">{{ lang == 'en' ? item.enTitle : item.title }}</div>
                    </div>
                </div>

                <el-pagination
                    class="elpagination"
                    background
                    layout="prev, pager, next"
                    :total="pageData3.count"
                    :current-page="pageData3.page"
                    :page-size="pageData3.pageNum"
                    @current-change="changePage"
                >
                </el-pagination>
            </div>

            <!-- 发展历程 -->
            <div class="myPageBox4" v-show="pageType == 3">
                <div class="topTitle">{{ $t('发展历程') }}</div>
                <div class="introBox" v-if="pageData4.list.length > 0">
                    <div class="year">{{ pageData4.list[pageData4.activeIndex].year }}</div>
                    <div class="title">
                        {{ lang == 'en' ? pageData4.list[pageData4.activeIndex].enTitle : pageData4.list[pageData4.activeIndex].title }}
                    </div>
                    <div class="introText">
                        {{ lang == 'en' ? pageData4.list[pageData4.activeIndex].enContent : pageData4.list[pageData4.activeIndex].content }}
                    </div>
                </div>

                <div class="timeLine">
                    <div class="greyLine"></div>
                    <div
                        class="dianBox"
                        @click="goYear(index)"
                        :class="{ active: !!(pageData4.activeIndex == index) }"
                        v-for="(item, index) in pageData4.list"
                        :key="index"
                    >
                        <div class="dian"></div>
                        <div class="yearText">{{ item.year }}</div>
                    </div>
                </div>
            </div>

            <!-- 生产线展示 -->
            <div class="myPageBox5" v-show="pageType == 4">
                <div class="topTitle">{{ $t('生产线展示') }}</div>
                <div class="lineBigBox">
                    <div class="title">{{ $t('爵士鼓生产线') }}</div>
                    <div class="titleLine"></div>
                    <div class="lineFlexBox">
                        <div class="lineImgBox" v-for="(item, index) in pageData5.jueshi" :key="index">
                            <el-image class="lineImg" :src="item.image" :preview-src-list="[item.image]" :initial-index="0" fit="cover"></el-image>
                            <div class="lineTitle">{{ lang == 'en' ? item.enTitle : item.title }}</div>
                        </div>
                    </div>
                </div>
                <div class="lineBigBox">
                    <div class="title">{{ $t('电鼓生产线') }}</div>
                    <div class="titleLine"></div>
                    <div class="lineFlexBox">
                        <div class="lineImgBox" v-for="(item, index) in pageData5.diangu" :key="index">
                            <el-image class="lineImg" :src="item.image" :preview-src-list="[item.image]" :initial-index="0" fit="cover"></el-image>
                            <div class="lineTitle">{{ lang == 'en' ? item.enTitle : item.title }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="fill100"></div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import pageBreadcrumb from '@/components/page/page-breadcrumb.vue'

export default {
    name: 'about',
    components: {
        pageBreadcrumb,
    },
    data() {
        return {
            nav_option: [],
            pageType: 0, // 页面状态：0.公司简介，1.创始人介绍，2.企业荣誉，3.发展历程，4.生产线展示

            pageData: {}, // 公司简介数据
            pageData2: {
                list: [],
            }, // 创始人介绍数据
            pageData3: {
                list: [],
                count: 0,
                page: 1,
                pageNum: 10,
            }, // 企业荣誉数据
            pageData4: {
                activeIndex: 0,
                list: [],
            }, // 发展历程数据
            pageData5: [], // 生产线展示数据
        }
    },
    computed: {
        ...mapState([]),
    },
    watch: {},
    created() {
        this.nav_option = [
            { title: this.$t('首页'), path: '/' },
            { title: this.$t('关于海伦'), path: '' },
        ]
        this.getAboutUs() // 关于我们
        this.getOriginator() // 创始人简介
        this.getHonorList() // 企业荣誉
        this.getDevelopLists() // 发展历程
        this.getprlineLists() // 生产线
    },
    methods: {
        async getprlineLists() {
            let obj = {}
            let res = await this.prlineListsAjax(obj)
            if (res && res.code == 200) {
                let data = res.data.list
                this.pageData5 = data
            }
        },
        prlineListsAjax(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'prline_lists',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        goYear(index) {
            this.pageData4.activeIndex = index
        },
        async getDevelopLists() {
            let obj = {}
            let res = await this.developListsAjax(obj)
            if (res && res.code == 200) {
                let data = res.data
                this.pageData4.list = data.list
            }
        },
        developListsAjax(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'develop_lists',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        async getHonorList() {
            let pageData3 = this.pageData3
            let obj = {
                page: pageData3.page,
                pageNum: pageData3.pageNum,
            }
            let res = await this.honorListsAjax(obj)
            if (res && res.code == 200) {
                let data = res.data
                this.pageData3.count = data.count
                this.pageData3.list = data.list
            }
        },
        honorListsAjax(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'honor_lists',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        async getAboutUs() {
            let obj = {
                channelId: 10,
                id: 95,
            }
            // this.$load.open()
            let res = await this.newsDetailsAjax(obj)
            // this.$load.close()
            if (res && res.code == 200) {
                let data = res.data.info
                this.pageData = data
                if (data.expand1) {
                    let arr = data.expand1.split(',')
                    this.pageData.expand1Num = arr[0]
                    this.pageData.expand1Text = arr[1]
                }
                if (data.expand2) {
                    let arr = data.expand2.split(',')
                    this.pageData.expand2Num = arr[0]
                    this.pageData.expand2Text = arr[1]
                }
            }
        },
        newsDetailsAjax(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'news_detail',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        async getOriginator() {
            let obj = {
                channelId: 52,
                contentLen: 1,
            }
            let res = await this.newsListsAjax(obj)
            if (res && res.code == 200) {
                this.pageData2.list = res.data.list
            }
        },
        newsListsAjax(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'news_lists',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        changePage(index) {
            this.pageData3.page = index
            this.getHonorList()
        },
        goArtistDetail() {
            this.$router.push('/artistDetail')
        },
        switchPageType(val) {
            this.pageType = val
        },
    },
}
</script>

<style scoped lang="less">
.topBox {
    width: 100%;
    height: 400px;
    background: url('../../assets/img/about/topBg.png') no-repeat;
    background-size: 100% 100%;
    overflow: hidden;
    margin-bottom: 50px;

    .topTitle {
        width: 100%;
        text-align: center;
        margin-top: 100px;
        font-size: 55px;
        line-height: 55px;
        color: #ffffff;
        font-family: 'myTextStyle';
        margin-bottom: 23px;
    }

    .topTitle2 {
        width: 100%;
        text-align: center;
        font-weight: bold;
        font-size: 55px;
        line-height: 55px;
        color: #ffffff;
        margin-bottom: 110px;
    }

    .line {
        width: 155px;
        height: 3px;
        background: #ffffff;
        margin: 0 auto;
    }
}

.wrap {
    width: 1600px;
    overflow: hidden;
    margin: 0 auto;
}

.topTypeFlexBox {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 38px;

    .title {
        font-weight: 400;
        font-size: 20px;
        color: #000000;
        line-height: 20px;
        cursor: pointer;

        &:hover {
            color: #ff4d00;
        }

        &.active {
            color: #ff4d00;
        }
    }

    .line {
        margin: 0 30px;
        background: #000000;
        width: 1px;
        height: 20px;
    }
}

.myPageBox {
    margin-top: 30px;

    .bigFlexBox {
        width: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;

        .leftBox {
            width: 750px;
            min-height: 840px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-direction: column;

            .title {
                width: 100%;
                font-weight: bold;
                text-align: start;
                font-size: 24px;
                color: #000000;
                line-height: 34px;
                margin-bottom: 30px;
            }

            .introStr {
                text-align: start;
                width: 100%;
                font-size: 16px;
                color: #888888;
                line-height: 34px;
            }

            .bottomNumBox {
                width: 100%;
                display: flex;
                align-items: flex-end;
                justify-content: space-between;

                .bigNumBox {
                    display: flex;
                    align-items: flex-end;
                    justify-content: flex-start;
                    .bigNum {
                        font-weight: 900;
                        font-size: 50px;
                        line-height: 70px;
                        color: #ff4d00;
                        position: relative;

                        .addNum {
                            font-weight: 900;
                            font-size: 24px;
                            color: #ff4d00;
                            position: relative;
                            top: -36px;
                        }
                    }

                    .bigNumText {
                        font-weight: 500;
                        font-size: 25px;
                        line-height: 70px;
                        color: #000000;
                    }
                }

                .bigNumNorText {
                    font-weight: 400;
                    font-size: 25px;
                    line-height: 25px;
                    color: #000000;
                }
            }
        }

        .rightBox {
            width: 750px;
            height: 840px;

            .img {
                width: 750px;
                height: 840px;
            }
        }
    }
}

.myPageBox2 {
    margin-top: 30px;

    .topTitle {
        font-weight: bold;
        font-size: 24px;
        color: #000000;
        line-height: 34px;
        margin-bottom: 50px;
    }

    .flexBox {
        width: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;

        .peopleImg {
            width: 357px;
            height: 460px;
        }

        .rightBox {
            width: 1175px;
            overflow: hidden;

            .nameFlexBox {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                margin-bottom: 50px;
                margin-top: 10px;

                .name {
                    font-weight: bold;
                    font-size: 22px;
                    color: #000000;
                    line-height: 32px;
                    margin-right: 34px;
                }

                .name2 {
                    font-weight: bold;
                    font-size: 18px;
                    line-height: 32px;
                    color: #555555;
                }
            }

            .contentText {
                font-weight: 400;
                font-size: 16px;
                color: #888888;
                line-height: 34px;
            }
        }
    }

    .line {
        width: 100%;
        height: 1px;
        background: rgba(0, 0, 0, 0.3);
        margin: 50px 0;
    }
}

.myPageBox3 {
    margin-top: 30px;

    .topTitle {
        font-weight: bold;
        font-size: 24px;
        color: #000000;
        line-height: 34px;
        margin-bottom: 100px;
    }

    .flexBox {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;

        .imgBox {
            width: 260px;
            cursor: pointer;
            margin-right: 72px;
            margin-bottom: 60px;
            transition: 0.5s all;
            position: relative;

            .img {
                width: 100%;
                height: 360px;
            }

            .title {
                width: 100%;
                text-align: center;
                margin-top: 26px;
                font-size: 20px;
                color: #000000;
                line-height: 20px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }

            &:nth-child(5n) {
                margin-right: 0;
            }

            &:hover {
                transform: translateY(-20px);

                .title {
                    color: #ff4d00;
                }
            }
        }
    }

    .elpagination {
        text-align: center;
    }
}

.myPageBox4 {
    margin-top: 30px;
    margin-bottom: 40px;

    .topTitle {
        font-weight: bold;
        font-size: 24px;
        color: #000000;
        line-height: 34px;
        margin-bottom: 100px;
    }

    .introBox {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        margin-bottom: 150px;

        .year {
            width: 850px;
            text-align: center;
            font-weight: 900;
            font-size: 100px;
            color: #ff4d00;
            line-height: 100px;
            margin-bottom: 38px;
        }

        .title {
            width: 850px;
            text-align: center;
            font-weight: bold;
            font-size: 30px;
            color: #000000;
            line-height: 35px;
            margin-bottom: 50px;
        }

        .introText {
            width: 850px;
            text-align: center;
            font-weight: 400;
            font-size: 20px;
            color: #444444;
            line-height: 35px;
        }
    }

    .timeLine {
        width: 100%;
        height: 34px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        position: relative;

        .greyLine {
            width: 100%;
            height: 1px;
            background: rgba(0, 0, 0, 0.8);
            position: absolute;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
        }

        .dianBox {
            width: 33px;
            height: 33px;
            background: transparent;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            position: relative;
            cursor: pointer;

            .dian {
                width: 12px;
                height: 12px;
                background: rgba(0, 0, 0, 1);
                border-radius: 50%;
            }

            .yearText {
                font-weight: 400;
                font-size: 20px;
                color: rgba(0, 0, 0, 1);
                line-height: 40px;
                position: absolute;
                bottom: -40px;
                left: 50%;
                transform: translateX(-50%);
            }

            &:hover {
                background: #ff4d00;

                .dian {
                    background: rgba(255, 255, 255, 1);
                }

                .yearText {
                    font-size: 25px;
                }
            }

            &.active {
                background: #ff4d00;

                .dian {
                    background: rgba(255, 255, 255, 1);
                }

                .yearText {
                    font-size: 25px;
                }
            }
        }
    }
}

.myPageBox5 {
    margin-top: 30px;

    .topTitle {
        font-weight: bold;
        font-size: 24px;
        color: #000000;
        line-height: 34px;
        margin-bottom: 40px;
    }

    .lineBigBox {
        width: 100%;
        margin-bottom: 30px;

        &:last-child {
            margin-bottom: 0;
        }

        .title {
            width: 100%;
            text-align: center;
            font-weight: bold;
            font-size: 22px;
            color: #ff4d00;
            line-height: 30px;
        }

        .titleLine {
            width: 100%;
            height: 2px;
            background: rgba(0, 0, 0, 0.3);
            margin: 20px 0 68px 0;
        }

        .lineFlexBox {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            flex-wrap: wrap;

            .lineImgBox {
                width: 470px;
                margin-right: 94px;
                margin-bottom: 30px;

                .lineImg {
                    width: 470px;
                    height: 300px;
                    margin-bottom: 20px;
                }

                .lineTitle {
                    width: 100%;
                    font-weight: 400;
                    font-size: 18px;
                    color: #000000;
                    line-height: 24px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }

                &:nth-child(3n) {
                    margin-right: 0;
                }
            }
        }
    }
}

.fill100 {
    width: 100%;
    height: 100px;
}
</style>
<style scoped lang="less" src="@/assets/h5css/mobile/about.less"></style>
